import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import httpclient from "../../components/httpclient";
import Title from "../../components/common/Title/Title";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../components/common/Table/CustomTable";
import { initFilterInput, initForm, renderColumns } from "./constants";
import Swal from "sweetalert2";
import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";
import ModalAdd from "./components/ModalAdd";
import IsEmpty from "../../components/helpers/IsEmpty";

const Outlet = () => {
  const [records, setRecords] = useState();
  const [modalAdd, setModalAdd] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [form, setForm] = useState(initForm);
  const [errors, setErrors] = useState({});
  const [id, setId] = useState();

  useEffect(() => {
    getData();
  }, [filterInput]);

  const handleTableChange = (pagination) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!form.name) {
      newErrors.name = "Nama outlet harus diisi";
    }
    if (!form.outletCode) {
      newErrors.outletCode = "Kode outlet harus diisi";
    }
    if (!form.address) {
      newErrors.address = "Alamat outlet harus diisi";
    }
    if (!id) {
      if (!form.initCapital) {
        newErrors.initCapital = "Modal awal harus diisi";
      }
      if (!form.initPettyCash) {
        newErrors.initPettyCash = "Kas awal harus diisi";
      }
    }

    if (form.type === "external") {
      if (!form.loanCommission) {
        newErrors.loanCommission = "Komisi pinjaman harus diisi";
      }
      if (!form.loanCommissionNoCapital) {
        newErrors.loanCommissionNoCapital =
          "Komisi pinjaman tanpa bunga harus diisi";
      }
      if (!form.extensionCommission) {
        newErrors.extensionCommission = "Komisi perpanjangan harus diisi";
      }
      if (!form.extensionCommissionNoCapital) {
        newErrors.extensionCommissionNoCapital =
          "Komisi perpanjangan tanpa bunga harus diisi";
      }
      if (!form.commissionCut) {
        newErrors.commissionCut = "potongan komisi harus diisi";
      }
      if (!form.commissionCutNoInterest) {
        newErrors.commissionCutNoInterest =
          "potongan komisi jika tanpa bunga harus diisi";
      }
    }

    return newErrors;
  };
  const handleSubmit = () => {
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      let data = {
        name: form.name,
        outlet_code: form.outletCode,
        description: "",
        address: form.address,
        phone: "",
        initial_capital: form.initCapital ?? 0,
        initial_petty_cash: form.initPettyCash ?? 0,
        status: form.status,
        type: form.type,
        outlet_settings: {
          commission_in_percent: form.loanCommission,
          zero_capital_commission_value_in_percent:
            form.loanCommissionNoCapital,
          zero_capital_commission_max_in_rupiah: form.maxLoanCommission || null,
          extension_commission_in_percent: form.extensionCommission,
          extension_zero_capital_commission_value_in_percent:
            form.extensionCommissionNoCapital,
          extension_zero_capital_commission_max_in_rupiah:
            form.maxExtensionCommission || null,
          commission_cut_when_agent_exists: form.commissionCut,
          zero_capital_commission_cut_when_agent_exists:
            form.commissionCutNoInterest,
        },
      };
      console.log(data);
      setSubmitting(true);
      if (IsEmpty(id)) {
        let url = `${process.env.REACT_APP_BASE_API_URL}outlet`;
        httpclient
          .POST(url, data)
          .then((response) => {
            console.log(response);
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            handleCloseModal();
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        let url = `${process.env.REACT_APP_BASE_API_URL}outlet/${id}`;
        httpclient
          .PUT(url, data)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            handleCloseModal();
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };

  const handleDelete = (record) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/${record.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus outlet " + record.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            handleCloseModal();
            setSubmitting(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          });
      }
    });
  };

  const handleEdit = (record) => {
    setModalAdd(true);
    setForm({
      name: record.name,
      outletCode: record.outletCode,
      description: "",
      address: record.address,
      phone: "",
      status: record.status,
      type: record.type,
      loanCommission: parseFloat(record.outlet_settings?.commission_in_percent),
      loanCommissionNoCapital: parseFloat(
        record.outlet_settings?.zero_capital_commission_value_in_percent
      ),
      maxLoanCommission: parseInt(
        record.outlet_settings?.zero_capital_commission_max_in_rupiah
      ),
      extensionCommission: parseFloat(
        record.outlet_settings?.extension_commission_in_percent
      ),
      extensionCommissionNoCapital: parseFloat(
        record.outlet_settings
          ?.extension_zero_capital_commission_value_in_percent
      ),
      maxExtensionCommission: parseInt(
        record.outlet_settings?.extension_zero_capital_commission_max_in_rupiah
      ),
      commissionCut: parseFloat(
        record.outlet_settings?.commission_cut_when_agent_exists
      ),
      commissionCutNoInterest: parseFloat(
        record.outlet_settings?.zero_capital_commission_cut_when_agent_exists
      ),
    });
    setId(record.id);
  };

  const getData = () => {
    let params = {
      name: filterInput.searchName,
      page: filterInput.page,
      size: filterInput.pageSize,
    };
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        console.log(convertOutlet(response.data.data.items));
        setRecords(convertOutlet(response.data.data.items));
        setTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const convertOutlet = (data) => {
    let converted = [];

    if (!data) return [];

    data.forEach((item, index) => {
      converted.push({
        key: index + 1,
        name: item.name,
        outletCode: item.outlet_code,
        tipe: item.type === "internal" ? "Internal" : "Eksternal",
        address: item.address,
        commission: item?.outlet_settings
          ? item?.outlet_settings?.commission_in_percent + "%"
          : "-",
        ...item,
      });
    });
    return converted;
  };

  const searchData = (name) => {
    setFilterInput((prev) => ({
      ...prev,
      searchName: name,
    }));
  };

  const onChangeStatus = () => {
    setForm((prev) => ({
      ...prev,
      status: !form.status,
    }));
  };

  const handleCloseModal = () => {
    setModalAdd(false);
    setForm(initForm);
    setId();
    setErrors({});
  };
  const onChangeRadio =
    (field = "") =>
    (e) => {
      setForm((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    };

  const handleChange =
    (field = "") =>
    (event) => {
      const { floatValue } = event;
      setForm((prev) => ({
        ...prev,
        [field]: floatValue == undefined ? null : parseFloat(floatValue),
      }));
    };

  const handleChangeInput = (event) => {
    const { value, id } = event.target;
    setForm((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return (
    <>
      <div>
        <div className="px-3">
          <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Daftar Cabang Outlet"} />
            <Breadcrumb current={"Cabang Outlet"} />
          </div>
          <div className="d-flex pt-3">
            <div className="">
              {/* Nama Cabang : */}
              <input
                type="text"
                className="form-control border-97A0AE"
                placeholder="Cari nama outlet"
                onChange={(e) => searchData(e.target.value)}
              />
            </div>

            <CanAccess
              role={AuthorizationList.create_outlet}
              yes={
                <div className="ml-auto" onClick={() => setModalAdd(true)}>
                  <button className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold">
                    + Tambah Outlet
                  </button>
                </div>
              }
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <CustomTable
              columns={renderColumns(handleEdit, handleDelete)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>
      <ModalAdd
        visible={modalAdd}
        onClose={handleCloseModal}
        form={form}
        onChangeRadio={onChangeRadio}
        handleChangeInput={handleChangeInput}
        handleChangeNumber={handleChange}
        onSubmit={handleSubmit}
        errors={errors}
        onChangeStatus={onChangeStatus}
        submitting={submitting}
        id={id}
      />
    </>
  );
};

export default Outlet;
